export const FullWidthBgImage = ({
  image,
  label,
  text,
  properties,
  descp,
  miles,
  height,
  borderRadius,
}) => {
  const truncateText = (text, charLimit) => {
    if (!text) return "";
    return text.length > charLimit ? text.slice(0, charLimit) + "..." : text;
  };
  return (
    <div
      className="bg-image-container"
      // style={{ backgroundImage: `url(${image})`, borderRadius, height }}
      style={{
        borderRadius,
        boxShadow: " 0px 1px 0px 0px  rgba(0, 0, 0, 0.2)",
      }}
    >
      <div className="gradient ">
        <div className="">
          <img
            src={image}
            style={{ width: "100%", height: "250px" }}
            loading="lazy"
          />
        </div>
      </div>
      <div className="text-container">
        <h3>{truncateText(text, 20)}</h3>
        <div
          className="d-flex align-items-center justify-content-between "
          style={{ gap: 90 }}
        >
          {properties && miles && (
            <>
              <p className="fs-8">{properties} properties</p>
              <p className="fs-8">{miles} miles away</p>
            </>
          )}
          {descp && <p className="fs-8 mt-2">{truncateText(descp, 75)}</p>}
        </div>
      </div>
    </div>
  );
};
